import _RentalTripPaymentService from "../services/rental-trip-payment-service";
import { IRentalTripPaymentService } from "../types/services/rental-trip-payment-service";

const instance = new _RentalTripPaymentService();

const RentalTripPaymentService: IRentalTripPaymentService = instance;

export default RentalTripPaymentService;
